import React from 'react';

const TermsPage = () => {
  return (
    <div className="public-website">
      <div className="container">
        <h1>Terms of Service Page</h1>
        <p>Terms of service page coming soon...</p>
      </div>
    </div>
  );
};

export default TermsPage; 